import './style.scss'
import { Button, Modal } from 'antd'
import dayjs from 'dayjs'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import * as Api from '@/api/account'
import { showPlanModal } from '@/libs/util'

interface IProps {
  open: boolean
  onCancel?: () => void
}

interface IVipPlan {
  level: number
  package_title: string
  start_time: number
  end_time: number
  duration_type: number
  units: number
}

const VipManagementModal: FC<IProps> = (props) => {
  const { t: translate } = useTranslation(['vip_management_modal'])
  const { open, onCancel } = props
  const [data, setData] = useState<IVipPlan[]>([])

  useEffect(() => {
    if (open) {
      getData()
    }
  }, [open])

  const getData = async () => {
    const res = await Api.getNextMembershiTerms()
    setData(res.list || [])
  }

  return (
    <Modal
      onCancel={onCancel}
      title={translate('vip_management_modal.title')}
      open={!!open}
      width={800}
      className="commom-modal vip-management-modal"
      footer={
        <Button
          className="vip-management-footer-btn"
          type="primary"
          onClick={() => {
            onCancel?.()
            showPlanModal()
          }}
        >
          {translate('vip_management_modal.renew_upgrade_button')}
        </Button>
      }
    >
      <div className="vip-management-main">
        <div className="vip-plans-container">
          {data.map((plan, index) => (
            <>
              {index === 1 && <div className="tips">{translate('vip_management_modal.multiple_plans_tip')}</div>}
              <div key={index} className={`vip-plan-box level-${plan.level}`}>
                <div className="plan-header">
                  <h3>
                    <span>{plan.package_title}</span>
                    {index === 0 && (
                      <span className="tag">
                        <label className="gradient">{translate('vip_management_modal.active_tag')}</label>
                      </span>
                    )}

                    {index === 1 && (
                      <span className="tag">
                        <label className="gradient">{translate('vip_management_modal.upcoming_tag')}</label>
                      </span>
                    )}
                  </h3>
                </div>
                <div className="plan-footer">
                  <div className="time-info">
                    <span>
                      {translate('vip_management_modal.start_time')}:{' '}
                      {dayjs.unix(plan.start_time).format('YYYY/MM/DD HH:mm:ss')}
                    </span>
                    <span>
                      {translate('vip_management_modal.end_time')}:{' '}
                      {dayjs.unix(plan.end_time).format('YYYY/MM/DD HH:mm:ss')}
                    </span>
                  </div>
                </div>
              </div>
            </>
          ))}
        </div>
      </div>
    </Modal>
  )
}

export default VipManagementModal
